import type React from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import CheckInFilledIcon from 'assets/icons/icn _ 24px _ check-in-filled.svg?react';
import StandardButton from 'components/buttons/StandardButton';
import { useStyles } from 'components/panels/eventsSplitDraws/avoidance/avoidancePanel/styles';
import StandardPaper from 'components/papers/standard/StandardPaper';
import { BodyLarge } from 'components/typography/Typography';
import { type ParticipantInterface } from 'typedefs/store/tmxTypes';

interface AvoidancePanelProps {
  existingRules: string[];
  existingGroups: ParticipantInterface[];
  onAddAvoidance?: () => void;
}

const AvoidancePanel: React.FC<React.PropsWithChildren<AvoidancePanelProps>> = ({
  existingGroups,
  existingRules,
  onAddAvoidance,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const renderAvoidanceText = () => {
    const text = existingRules ? (
      <Typography>
        There are <span className={classes.avoidancePanelTypographyBold}>{existingRules?.length || 0} rules</span> and{' '}
        <span className={classes.avoidancePanelTypographyBold}>{existingGroups?.length || 0} player groups</span> set
        for this draw
      </Typography>
    ) : (
      <BodyLarge>{t('avoidancePanel.content')}</BodyLarge>
    );
    return existingRules ? (
      <>
        <Grid item className={classes.avoidanceIcon}>
          <CheckInFilledIcon />
        </Grid>
        <Grid item>{text}</Grid>
      </>
    ) : (
      <Grid item>{text}</Grid>
    );
  };
  return (
    <StandardPaper className={classes.avoidancePaper}>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item>
          <Grid container direction="column">
            <Grid item className={classes.avoidanceTitleTypography}>
              <Typography variant="h1">{t('drawAvoidance')}</Typography>
            </Grid>
            <Grid item>
              <Grid container direction="row">
                {renderAvoidanceText()}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <StandardButton onClick={onAddAvoidance}>
            {existingRules?.length > 0 || existingGroups?.length > 0 ? t('editAvoidances') : t('addAvoidances')}
          </StandardButton>
        </Grid>
      </Grid>
    </StandardPaper>
  );
};

export default AvoidancePanel;
